<template>
  <div class="field-wrapper">
    <label class="item-wrapper">
      <span class="label" :class="{ 'label--visible': value }">
        {{ label }}
      </span>

      <component
        :is="isTextarea ? 'textarea' : 'input'"
        ref="item"
        :value="value"
        :placeholder="placeholder"
        :type="type"
        :disabled="disabled"
        class="item"
        :class="{ 'item--textarea': isTextarea }"
        required
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </label>

    <error :error="error" />
  </div>
</template>

<script>
import Error from './Error'

export default {
  components: {
    Error
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    errors: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBlurred: true
    }
  },
  computed: {
    isTextarea() {
      return this.type === 'textarea'
    },
    error() {
      return this.isBlurred && this.errors[0] ? this.errors[0] : ''
    }
  },
  methods: {
    handleInput() {
      const { item } = this.$refs
      this.$emit('input', item.value)
      this.$emit('change')

      if (this.type === 'textarea') {
        // vertical resizing textarea depending on text height
        item.style.height = '34px'
        item.style.height = item.scrollHeight + 'px'
      }
    },
    handleBlur() {
      this.isBlurred = true
    },
    handleFocus() {
      this.isBlurred = false
    }
  }
}
</script>

<style lang="scss" scoped>
.field-wrapper {
  position: relative;
}

.item-wrapper {
  @include center-content;
  position: relative;

  margin-bottom: 42px;

  @include media-down(xl) {
    margin-bottom: 27px;
  }

  @include media-down(lg) {
    margin-bottom: 54px;
  }

  @include media-down(md) {
    margin-bottom: 20px;
  }
}

.label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  color: $label-color;

  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 10px;

  filter: contrast(1.5);

  @include media-down(xl) {
    font-size: 9px;
  }

  @include media-down(lg) {
    font-size: 21px;
  }

  @include media-down(md) {
    font-size: 10px;
  }

  opacity: 0;
  transition: opacity 0.2s;

  &--visible {
    opacity: 1;
  }
}

.item {
  @include reset-input;
  display: block;
  width: 100%;

  color: $text-color;
  font-size: 18px;
  font-family: $light-font;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid $text-color;

  padding: 15px 0 7px;

  &::placeholder {
    color: $text-color;
    opacity: 1;
  }

  @include media-down(xl) {
    font-size: 12px;
    border-width: 1px;
    padding: 11px 0 5px;
  }

  @include media-down(lg) {
    font-size: 26px;
    border-width: 3px;
    padding: 28px 0 11px;
  }

  @include media-down(md) {
    font-size: 12px;
    border-width: 1px;
    padding: 13px 0 6px;
  }

  &--textarea {
    resize: none;
    min-height: 120px;
    height: auto;

    overflow-y: hidden;

    @include media-down(xl) {
      min-height: 92px;
    }

    @include media-down(lg) {
      min-height: 180px;
    }

    @include media-down(md) {
      min-height: 34px;
      height: 34px;
    }
  }
}
</style>
